import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import EventsTable from "../EventsTable/EventsTable";
import cloudLogo from '../../trimble-cloud-logo.png'
const useStyles = makeStyles({
    header: { 
        height: '60px',
        display: 'flex',
        alignItems: 'center',
        color: '#00437B',
        fontWeight: 'bolder',
        margin: '10px 0 20px',
        
    },
    logo:{
        width: '65px',
        height: '65px',
        marginRight: '20px' 
    },
    subHeader:{
        color: '#00437B',
        padding: '5px 0',
        margin: '10px 0 20px 0',
        borderBottom: 'solid 2px #9D9DA6',
        fontSize: '1.4em',
    },

  });


const AvailableEvents: React.FC = () => {

    const styles = useStyles();

        return(
            <React.Fragment>
                <div className={styles.header}>
                    <img src={cloudLogo} className={styles.logo} alt="BigCo Inc. logo"/>
                    <Typography variant="h4"  component="h2">Event Service</Typography>
                </div>
                <div className={styles.subHeader} >
                    <Typography variant="h6"   component="div">Available Events</Typography>
                </div>
                <EventsTable/>
            </React.Fragment>
        )
}

export default AvailableEvents;



